import { Avatar, Space, Typography } from 'antd'

import { IStudent } from '~/types/student'

type Props = {
  student?: Partial<IStudent> | null
  profileImgUrl?: string | null
  name?: string | null
  showName?: boolean
}

const StudentAvatar = ({ student, profileImgUrl, name, showName = false }: Props) => {
  const avatarUrl = profileImgUrl ?? student?.profileImgUrl
  const studentName = name ?? student?.name
  const fallback = studentName?.trim()?.slice(0, 1) || '学'

  const avatar = (
    <Avatar
      size={40}
      src={avatarUrl || undefined}
      style={{ backgroundColor: '#1677ff', flex: '0 0 auto' }}
    >
      {fallback}
    </Avatar>
  )

  if (!showName) {
    return avatar
  }

  return (
    <Space size={8}>
      {avatar}
      <Typography.Text>{studentName || '-'}</Typography.Text>
    </Space>
  )
}

export default StudentAvatar
